/* unplugin-vue-components disabled */import script from "./my-org-audit-flow-cfg-list.vue?vue&type=script&setup=true&lang=js"
export * from "./my-org-audit-flow-cfg-list.vue?vue&type=script&setup=true&lang=js"

import "./my-org-audit-flow-cfg-list.vue?vue&type=style&index=0&id=08262da8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08262da8"]])

export default __exports__